import {commentator} from '@utilities/sal-commentator/sal-commentator';
import {breakpoints} from '@utilities/sal-breakpoint/sal-breakpoint';
import {animation} from '@utilities/sal-animation/sal-animation';
import {shopUtilities} from "@global/shop-utilities/shop-utilities";

const CONSTANTS = {
    CONTENT_SHOPPINGCART_CLASS: '.content-shoppingcart__container',
    CONTENT_SHOPPINGCART_TITLE_CLASS: '.content-shoppingcart__title',
    CONTENT_SHOPPINGCART_CONTENT_CLASS: '.content-shoppingcart__items',
    CONTENT_SHOPPINGCART_ICON_CLASS: '.icon-toggle',
    CONTENT_SHOPPINGCART_EXPANDED: 'minus',
    CONTENT_SHOPPINGCART_COLLAPSED: 'plus',
    CONTENT_SHOPPINGCART_BODY_SHOW: 'animation__direction--reverse',
    CONTENT_SHOPPINGCART_BODY_HIDE: 'animation__direction--forwards',
    ORDER_BUTTON: '.order',
    KEYVISUAL_CLASS: '.keyvisual .gallery__single',
    SIMULATED_CLICK: 'simulated'
};

const eventHandler = {
    repositionContentShoppingcart: () => {
        const contentShoppingcartElement = document.querySelector(CONSTANTS.CONTENT_SHOPPINGCART_CLASS);
        const keyvisualElement = document.querySelector(CONSTANTS.KEYVISUAL_CLASS);

        try {
            if (keyvisualElement && keyvisualElement.clientHeight) {
                contentShoppingcartElement.style.top = `${keyvisualElement.clientHeight}px`;
                commentator.insertCommentBefore(contentShoppingcartElement, 'shoppage.js', commentator.getPresets().STYLE);
            }
        }
        catch (e) {
            commentator.insertCommentBefore(contentShoppingcartElement, 'shoppage.js', 'Failed to set style *top*');
        }
    },
    toggleShoppingcartContent: (simulated) => {
        const shoppingcartIconElement = document.querySelector(CONSTANTS.CONTENT_SHOPPINGCART_ICON_CLASS);

        if (simulated === CONSTANTS.SIMULATED_CLICK) {
            let simulatedClick = new CustomEvent('simulatedClick');
            const contentNavTitle = document.querySelector(`.${animationOptions.classes.trigger}`);
            contentNavTitle.dispatchEvent(simulatedClick);
        }

        if (shoppingcartIconElement.classList.contains(CONSTANTS.CONTENT_SHOPPINGCART_COLLAPSED)) {
            shoppingcartIconElement.classList.remove(CONSTANTS.CONTENT_SHOPPINGCART_COLLAPSED);
            shoppingcartIconElement.classList.add(CONSTANTS.CONTENT_SHOPPINGCART_EXPANDED);

        } else {
            shoppingcartIconElement.classList.remove(CONSTANTS.CONTENT_SHOPPINGCART_EXPANDED);
            shoppingcartIconElement.classList.add(CONSTANTS.CONTENT_SHOPPINGCART_COLLAPSED);
        }
    },
    checkShoppingcartVisibility: () => {
        const shoppingcartIconElement = document.querySelector(CONSTANTS.CONTENT_SHOPPINGCART_ICON_CLASS);
        if (window.innerWidth > breakpoints.lg) {
            if (shoppingcartIconElement.classList.contains(CONSTANTS.CONTENT_SHOPPINGCART_COLLAPSED)) {
                eventHandler.toggleShoppingcartContent(CONSTANTS.SIMULATED_CLICK);
            }
        } else {
            if (shoppingcartIconElement.classList.contains(CONSTANTS.CONTENT_SHOPPINGCART_EXPANDED)) {
                eventHandler.toggleShoppingcartContent(CONSTANTS.SIMULATED_CLICK);
            }
        }
    }
};

const animationOptions = {
    eventType: 'click',
    findTarget: CONSTANTS.MODE_CLOSEST,
    directions: 'next',
    classes: {
        trigger: 'content-shoppingcart__title',
        target: 'content-shoppingcart__content',
        parent: 'content-shoppingcart__title'
    },
    animation: {
        duration: 'animation__duration--500',
        type: 'animation__type--expand',
        forwards: CONSTANTS.CONTENT_SHOPPINGCART_BODY_HIDE,
        reverse: CONSTANTS.CONTENT_SHOPPINGCART_BODY_SHOW,
        toggle: 'true'
    }
};

const shoppage = {
    init: () => {
        const _shoppingcartDOM = document.querySelector('.layout-content-shoppingcart');
        if(_shoppingcartDOM !== null) {
            animation.init(animationOptions);

            window.addEventListener("resize", eventHandler.repositionContentShoppingcart);
            window.addEventListener("imageLoaded", eventHandler.repositionContentShoppingcart);
            eventHandler.repositionContentShoppingcart();

            // Open the shopping cart on large screens as animation.init automatially closes it.
            if (window.innerWidth > breakpoints.lg) {
                eventHandler.toggleShoppingcartContent(CONSTANTS.SIMULATED_CLICK);
            }

            const cartTitle = document.querySelector(CONSTANTS.CONTENT_SHOPPINGCART_TITLE_CLASS);

            cartTitle.addEventListener('click', eventHandler.toggleShoppingcartContent);
            window.addEventListener('resize', eventHandler.checkShoppingcartVisibility);

            const orderBtn = document.querySelector(CONSTANTS.CONTENT_SHOPPINGCART_CLASS + " " + CONSTANTS.ORDER_BUTTON);
            const itemArea = document.querySelector(CONSTANTS.CONTENT_SHOPPINGCART_CONTENT_CLASS);

            if(itemArea.querySelector(".shoppingcart--no-results")) {
                if(orderBtn && !orderBtn.classList.contains('inactive')) {
                    orderBtn.classList.add('inactive');
                    orderBtn.href = "";
                }
            } else {
                if (orderBtn && orderBtn.classList.contains('inactive')) {
                    orderBtn.classList.remove('inactive');
                    orderBtn.href = window.page_cart;
                }
            }

            const initalCount = itemArea.querySelectorAll(`.cart-item`).length;
            if (cartTitle) {
                const cartCount = cartTitle.querySelector(`.cart--count`);
                if (cartCount) {
                    cartCount.innerText = `(${initalCount})`;
                }
            }
            shopUtilities.added((e) => {
                const noResultsElement = document.querySelector(`${CONSTANTS.CONTENT_SHOPPINGCART_CONTENT_CLASS} .shoppingcart--no-results`);
                const contentElement = document.querySelector(`${CONSTANTS.CONTENT_SHOPPINGCART_CONTENT_CLASS}`);
                if (noResultsElement !== null && !noResultsElement.classList.contains('hide')) {
                    noResultsElement.classList.add('hide');
                }

                if(itemArea.childElementCount === 0) {
                    if(!orderBtn.classList.contains('inactive')) {
                        orderBtn.classList.add('inactive');
                        orderBtn.href = "";
                    }
                } else {
                    if (orderBtn.classList.contains('inactive')) {
                        orderBtn.classList.remove('inactive');
                        orderBtn.href = window.page_cart;
                    }
                }

                const element = document.createElement("p");
                element.classList.add("cart-item");
                element.innerHTML = `
                    <strong>${e.detail.title}</strong><br>
                    ${e.detail.subtitle} ${e.detail.subsubtitle}
                `;

                contentElement.appendChild(element);

                const count = itemArea.querySelectorAll(`.cart-item`).length;
                cartTitle.querySelector(`.cart--count`).innerText = `(${count})`;

            }, false, 'cart');
        }
    }
};

export { shoppage };
